


































































import {getModule} from 'vuex-module-decorators';
import {Component, Mixins} from 'vue-mixin-decorator';

import {Notify} from '@/utils/Notify';

import {IpMode} from '@/model/network/IpMode';
import {DeviceStateColor} from '@/model/network/device/DeviceState';

import {AppStore} from '@/store/App.store';
import NetworkDevicesStore from '@/store/network/NetworkDevices.store';
import NetworkConnectionsStore from '@/store/network/NetworkConnections.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import PropertyDisplayer from '@/components/Utils/PropertyDisplayer.vue';
import NetworkConnectionSummary from '@/components/Networking/Connection/NetworkConnectionSummary.vue';

@Component({
  components: {NetworkConnectionSummary, PropertyDisplayer},
})
export default class NetworkEthernetStatus extends Mixins<BaseComponent>(BaseComponent) {
  private appStore: AppStore = getModule(AppStore, this.$store);

  private devicesStore: NetworkDevicesStore = getModule(NetworkDevicesStore, this.$store);

  private connectionsStore: NetworkConnectionsStore = getModule(NetworkConnectionsStore, this.$store);

  private IpMode = IpMode;
  private DeviceStateColor = DeviceStateColor;

  private async mounted() {
    this.setLoading();
    try {
      await this.devicesStore.fetchDevices(true);
      this.logger.trace('Devices fetched');
    } catch (error) {
      Notify.Error(this.logger, `Could not get network interfaces`, error);
    } finally {
      this.setLoaded();
    }
  }
}
